/** Fallback image shown when a product image is not available (used across Home sections). */
import bagsImage from "../../Assets/bags.png";

export const PLACEHOLDER_PRODUCT_IMAGE = bagsImage;
